export const selectStyle = {
    
    control: (provided, state) => ({
        ...provided,
        border: state.isFocused ? '1px solid rgb(203 213 225)' : '1px solid rgb(203 213 225)',
        boxShadow: state.isFocused ? 'none' : 'none',
        '&:hover': {
            border: state.isFocused ? '1px solid rgb(203 213 225)' : '1px solid rgb(203 213 225)', // Apply blue border on hover if focused, otherwise regular border
        },
        minHeight: "35px",
        width: '100%',
        cursor: 'pointer',
        borderRadius: '5px',
    }),


    indicatorSeparator: (provided) => ({
        ...provided,
        display: 'none',
    }),

    indicatorsContainer: (provided) => ({
        ...provided,
        //  display: 'none',  
        padding: '0px',
    }),

    dropdownIndicator: (provided) => ({
        ...provided,
        //display: 'none', 
        color: 'rgb(148 163 184)',
        padding: '4px',
        "svg": {
            width: '14px',
            height: '14px',
        }
    }),

    clearIndicator: (provided) => ({
        ...provided,
        //display: 'none', 
        color: 'rgb(148 163 184)',
        padding: '0px',
        "svg": {
            width: '14px',
            height: '14px',
        }
    }),

    option: (styles, { isDisabled, isFocused, isSelected }) => {
        let backgroundColor;
        let color;
        let cursor = isDisabled ? 'not-allowed' : 'pointer';

        if (isDisabled) {
            backgroundColor = undefined;
            color = 'rgb(71 85 105)';
        } else if (isSelected) {
            backgroundColor = '#f1f1f1';
            color = undefined;
        } else if (isFocused) {
            backgroundColor = '#f1f1f1';
            color = "rgb(71 85 105)";
        } else {
            backgroundColor = undefined;
            color = "rgb(71 85 105)";
        }

        let activeBackgroundColor;
        if (!isDisabled) {
            if (isSelected) {
                activeBackgroundColor = '#fff';
            } else {
                activeBackgroundColor = '#fff';
            }
        }

        return {
            ...styles,
            fontSize: '12px',
            color: 'rgb(51 65 85)',
            backgroundColor: backgroundColor,
            cursor: cursor,
            ':active': {
                ...styles[':active'],
                backgroundColor: backgroundColor,
            },
        };
    },

    placeholder: (provided, state) => ({
        ...provided,
        color: "rgb(71 85 105 / 60%)",
        fontSize: "12px",
    }),

    singleValue: (provided, state) => ({
        ...provided,
        color: "rgb(71 85 105)",
        fontSize: "12px",
    }),

    input: (provided, state) => ({
        ...provided,
        color: "rgb(71 85 105)",
        fontSize: "13px",
    }),

    

};

 